import Vue from 'vue';
import Axios from 'axios';
import store from '@/state/store';
import { axiosSwagger } from "@/axios";
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import VueJwtDecode from 'vue-jwt-decode';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import relativeTime from 'dayjs/plugin/relativeTime';


dayjs.extend(relativeTime)

let downloadFileManagerFiles = [];
let downloadFileProgress = null;
let fileProgress = {};

// File Types
Vue.prototype.$fileTypes = {
    text: ['txt', 'rtf', 'tex', 'wpd'],
    word: ['doc', 'docx', 'odt'],
    pdf: ['pdf'],
    
    spreadsheet: ['ods', 'xls', 'xlsm', 'xlsx', 'csv', 'xml'],
    image: ['ai', 'bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png', 'ps', 'psd', 'svg', 'tif', 'tiff'],
    video: ['3g2', '3gp', 'avi', 'flv', 'h264', 'm4v', 'mkv', 'mov', 'mp4', 'mpg', 'mpeg', 'rm', 'swf', 'vob', 'wmv'],
    music: ['aif', 'cda', 'mid', 'midi', 'mp3', 'mpa', 'ogg', 'wav', 'wma', 'wpl'],
    presentation: ['key', 'odp', 'pps', 'ppt', 'pptx'],
    compressed: ['7z', 'arj', 'deb', 'pkg', 'rar', 'rpm', 'tar.gz', 'gz', 'z', 'zip'],
}

async function fetchFile(fileUrl, fileType){
    return await Axios.get(fileUrl)
        .then((response) => {
            return new Blob([response.data], { type: fileType });
        })
        .catch((error) => {
            console.error('error fetchFile', error);
        })
}


// eslint-disable-next-line no-unused-vars
async function createBlob(fileUrl, fileType, type){
    if(type === 'image'){
        return await fetchFile(fileUrl, fileType);
    }
    else if(type === 'pdf'){
        // Get the PDF file as an ArrayBuffer
        const blobResponse = await fetchFile(fileUrl, fileType);
        return await blobResponse.arrayBuffer();
    }
}


async function getBlobFileData(id){
    return await Axios.get(`${Vue.prototype.$VUE_APP_SWAGGER_URL}/api/FileManagerFile/ReadFile/Stream/${id}`, { 
        headers: {
            Authorization: `Bearer ${localStorage.getItem('TOKEN')}`
        },
        responseType: "blob",
        
        onDownloadProgress: function  (progressEvent) {
            // downloadFileProgress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
            
            // save the individual file's progress percentage in object
            fileProgress[id] = progressEvent.loaded * 100 / progressEvent.total
            // sum up all file progress percentages to calculate the overall progress
            let totalPercent = fileProgress ? Object.values(fileProgress).reduce((sum, num) => sum + num, 0) : 0
            // divide the total percentage by the number of files
            downloadFileProgress = parseInt(Math.round(totalPercent / downloadFileManagerFiles.length))
        }.bind(this)
    })
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        console.error('error fetchFile', error);
    })
}


// download multple file
Vue.prototype.$downloadMultipleFile = async (item) => {
    if(item?.fileManagerFiles ?? false){
        let timerInterval;

        Vue.prototype.$swal({
            title: 'Downloading file .. Please wait',
            html: `<b id="multiple-file-download-progress-update">0</b>%`,
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Vue.prototype.$swal.showLoading();
                const b = Vue.prototype.$swal.getHtmlContainer().querySelector('#multiple-file-download-progress-update');
                
                timerInterval = setInterval(() => {
                    b.textContent = downloadFileProgress ||  0;
                }, 10)
            },
            willClose: () => {
                downloadFileProgress = null;
                fileProgress = {};
                clearInterval(timerInterval);
            }
        });

        const zip = new JSZip();
        const externalIterationCheck = [];
        downloadFileManagerFiles = item.fileManagerFiles;

        await item.fileManagerFiles.forEach( async (e, i) => {
            const fileData = await getBlobFileData(e.id);
            const fileUrl = URL.createObjectURL(fileData);

            await JSZipUtils.getBinaryContent(fileUrl, async function (err, data) {
                if(err) {
                   throw err; // or handle the error
                }

                await zip.file(e.fileName, data, { binary: true });

                externalIterationCheck.push(i);

                if (externalIterationCheck.length == item.fileManagerFiles.length) {
                    await zip.generateAsync({type:'blob'}).then(async function(content) {
                        await saveAs(content, item.name.replaceAll('.',"_"));
                        await new Promise(r => setTimeout(r, 1000)); 
                    });
                }
            });
    
        });

        Vue.prototype.$swal.close();
        
    
    }
    else{
        Vue.prototype.$toast.error('File not found.');
    }

    
}



// download single file
Vue.prototype.$downloadSingleFile = async (item) => {
    downloadFileManagerFiles = [item];
    let timerInterval;

    Vue.prototype.$swal({
        title: 'Downloading file .. Please wait',
        html: `<b id="single-file-download-progress-update">0</b>%`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
            Vue.prototype.$swal.showLoading();
            const b = Vue.prototype.$swal.getHtmlContainer().querySelector('#single-file-download-progress-update');
            
            timerInterval = setInterval(() => {
                b.textContent = downloadFileProgress ||  0;
            }, 10)
        },
        willClose: () => {
            downloadFileProgress = null;
            fileProgress = {};
            clearInterval(timerInterval);
        }
    });

    const fileData = await getBlobFileData(item.id);

    Vue.prototype.$swal.close();
    
    return saveAs(fileData, item.fileName);
}


Vue.prototype.$downloadFile = async (item) => {
    if(item.fileManagerFiles.length === 1){
        await Vue.prototype.$downloadSingleFile(item.fileManagerFiles[0]);
    }
    else if(item.fileManagerFiles.length > 1){
        await Vue.prototype.$downloadMultipleFile(item);
    }
    else{
        Vue.prototype.$toast.error('File not found.');
    }
}


Vue.prototype.$downloadFile2 = (item) => {
    const fileUrl = Vue.prototype.$VUE_APP_SWAGGER_URL + "/files/" + item.fileRealName;

    Axios.get(fileUrl, { responseType: 'blob' })
        .then(response => {
            const blob = new Blob([response.data], { type: item.fileType });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = item.name;
            link.click();
            URL.revokeObjectURL(link.href);

            return response;
        })
        .catch(() => {
            Vue.prototype.$toast.error('download error');
        })
}



/** MODALS */

Vue.prototype.$deleteModal = (name, action='') => {
    let _action = action !== '' ? action : 'delete';

    return Vue.prototype.$swal({
        title: `Are you sure you want to ${_action} this ${name}?`,
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        // cancelButtonColor: '#3085d6',
        confirmButtonText: `Yes, ${_action} it!`,
        // didOpen: onOpenModal,
        // didClose: onCloseModal,
    });
}

function getChildCount(item){
    if(item?.childFolders && item?.fileManagers){
        if(item.childFolders.length === 0 && item.fileManagers.length === 0){
            return '';
        }
    
        if(item.childFolders.length > 0 && item.fileManagers.length === 0){
            return `There are still ${item.childFolders.length} folder${item.childFolders.length > 1 ? 's' : ''} on it`;
        }
        else if (item.fileManagers.length > 0 && item.childFolders.length === 0){
            return `There are still ${item.fileManagers.length} file${item.fileManagers.length > 1 ? 's' : ''} on it`;
        }
        else{
            return `There are still ${item.childFolders.length} folder${item.childFolders.length > 1 ? 's' : ''} and ${item.fileManagers.length} file${item.fileManagers.length > 1 ? 's' : ''} on it`;
        }
    }

    return '';
}


Vue.prototype.$removeModal = (name, item) => {
    let text = getChildCount(item);

    return Vue.prototype.$swal({
        title: 'Are you sure you want to remove this '+ name + '?',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        // cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, remove it!',
        // didOpen: onOpenModal,
        // didClose: onCloseModal,
    });
}

Vue.prototype.$deleteForeverModal = (name) => {
    return Vue.prototype.$swal({
        title: 'Are you sure you want to permanently delete '+ name + '?',
        html: `<div>
            <span>You won't be able to revert this!</span><br>
            <span style="font-size: 16px; font-style: italic;">Type <span style="color: red;">DELETE</span> to continue.</span>
        </div>`,
        input: 'text',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        // cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!',
        inputValidator: (value) => {
            if (!value || value.toLowerCase() !== 'delete') {
              return "Please type \"DELETE\" to continue."
            }
        }
    });
}

Vue.prototype.$restoreModal = (name, type) => {
    return Vue.prototype.$swal({
        title: `This, ${name} , ${type} is in your trash`,
        text: `To view this ${type}, you'll need to restore it from your trash.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        // cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, restore it!',
        // didOpen: onOpenModal,
        // didClose: onCloseModal,
    });
}

/** MODALS */





/** TOAST */

/** TOAST */




Vue.prototype.$getUser = () => {
    return localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;
}


Vue.prototype.$getUserPreference = () => {
    return localStorage.getItem("USER_PREFERENCE") !== null ? JSON.parse(localStorage.getItem("USER_PREFERENCE")) : null;
}



// USING JWT
Vue.prototype.$isAdmin = () => {
    let token = localStorage.getItem("TOKEN") ? localStorage.getItem("TOKEN") : '';
    let decodeData = (token || false) ? VueJwtDecode.decode(token) : '';

    if(decodeData){
        return decodeData?.IsAdmin?.toLowerCase() === "true" ? true : false;
    }
    
    return false;
}

Vue.prototype.$isCru = () => {
    let token = localStorage.getItem("TOKEN") ? localStorage.getItem("TOKEN") : '';
    let decodeData = (token || false) ? VueJwtDecode.decode(token) : '';

    if(decodeData){
        return decodeData?.IsCru?.toLowerCase() === "true" ? true : false;
    }
    
    return false;
}

Vue.prototype.$isAdminAndClient = () => {
    return Vue.prototype.$isAdmin() || process.env.VUE_APP_CLIENT === 'ustp' || process.env.VUE_APP_CLIENT === 'magsaysay';
}

Vue.prototype.$isDebug = () => {
    return store.state.custom.isDebug || false;
}

Vue.prototype.$accessListData = () => {
    let token = localStorage.getItem("ACCESSLIST") ? JSON.parse(localStorage.getItem("ACCESSLIST")) : '';
    let decodeData = (token || false) ? VueJwtDecode.decode(token) : '';

    if(decodeData){
        return decodeData?.IsCru?.toLowerCase() === "true" ? true : false;
    }
    
    return false;
}

Vue.prototype.$decryptAccessList = (data) => {
    if(data){
        let salt = process.env.VUE_APP_SECRET_SALT;

        let encryptedText = data;
        var rawData = Vue.CryptoJS.enc.Base64.parse(encryptedText);
        var key = Vue.CryptoJS.enc.Latin1.parse(salt);
        var plaintextData = Vue.CryptoJS.AES.decrypt(
            { ciphertext: rawData },
            key,
            {
                iv: Vue.CryptoJS.enc.Latin1.parse(
                    ""
                ),
            }
        );
        var plaintext = plaintextData.toString(Vue.CryptoJS.enc.Latin1);

        return plaintext;
    }

    return null;
}


/// USING SALT
// Vue.prototype.$isAdmin = () => {
//     let userData = JSON.parse(localStorage.getItem("USER"));
    
//     if(userData){
//         let salt = process.env.VUE_APP_SECRET_SALT;

//         let encryptedText = userData?.isSaU;
//         var rawData = Vue.CryptoJS.enc.Base64.parse(encryptedText);
//         var key = Vue.CryptoJS.enc.Latin1.parse(salt);
//         var plaintextData = Vue.CryptoJS.AES.decrypt(
//             { ciphertext: rawData },
//             key,
//             {
//                 iv: Vue.CryptoJS.enc.Latin1.parse(
//                     ""
//                 ),
//             }
//         );
//         var plaintext = plaintextData.toString(Vue.CryptoJS.enc.Latin1);
//         return plaintext.toLowerCase() === "true" ? true : false;
//     }

//     return false;
// }


Vue.prototype.$dayjs = (date) => {
    return dayjs(date);
}

// date time format
Vue.prototype.$dateTimeFormat = (dateTime) => {
    return dayjs(dateTime).format('MMM DD YYYY h:mm a');
}

// date format
Vue.prototype.$dateFormat = (date) => {
    return dayjs(date).format('MMM DD YYYY');
}

// time format
Vue.prototype.$timeFormat = (time) => {
    return dayjs(time).format('h:mm a');
}

// get date string format for document date in file upload
// e.g "2023-09-19"
Vue.prototype.$getDateStringFormat = (date) => {
    if(!date){
        const datenow = new Date();
        return dayjs(datenow).format('YYYY-MMM-DD ');
    }

    return dayjs(date).format('YYYY-MMM-DD ');
}

// get date from now based on how many years
Vue.prototype.$getDateFromNow = (date, howManyYears) => {
    return dayjs(date).add(howManyYears, 'year').format('MMM DD YYYY');
}


Vue.prototype.$dateExpireLapse = (date, howManyYears) => {
    let dateExpired = dayjs(date).add(howManyYears, 'year');

    return dayjs().isAfter(dateExpired, 'day');
}

// get time ago
Vue.prototype.$timeAgo = (date, howManyYears) => {
    let a = dayjs(date).add(howManyYears, 'year').format('MMM DD YYYY');
    return dayjs(a).toNow(true);
}


// get file extension
Vue.prototype.$getFileExtension = (fileName) => {
    return (fileName.substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName).toLowerCase();
}


// get file icon
Vue.prototype.$getFileIcon = (fileName) => {
    let fileExt = Vue.prototype.$getFileExtension(fileName);
    let file = Vue.prototype.$fileTypes;


    if(file.text.includes(fileExt)){
        return 'mdi-file-document text-secondary';
    }
    else if(file.word.includes(fileExt)){
        return 'mdi-file-word text-primary';
    }
    else if(file.pdf.includes(fileExt)){
        return 'mdi-file-pdf text-danger';
    }
    else if(file.spreadsheet.includes(fileExt)){
        return 'mdi-file-excel text-teal';
    }
    else if(file.image.includes(fileExt)){
        return 'mdi-file-image text-pink';
    }
    else if(file.video.includes(fileExt)){
        return 'mdi-file-video text-info';
    }
    else if(file.music.includes(fileExt)){
        return 'mdi-file-music text-purple';
    }
    else if(file.presentation.includes(fileExt)){
        return 'mdi-file-powerpoint text-orange';
    }
    else if(file.compressed.includes(fileExt)){
        return 'mdi-zip-box text-warning';
    }
    else{
        return 'mdi-file text-dark';
    }
}

Vue.prototype.$getDocIcon = (files) => {
    // let totalFiles = files?.length ?? 0;
    let imageTypes = ['image/png', 'image/jpg', 'image/jpeg'];
    let fileTypes = [];
    let iconColor = 'mdi mdi-file-document text-orange';


    if(files){
        files?.forEach(e => {
            fileTypes.push(e.fileType);
        });
        
        if ( fileTypes?.includes('application/pdf') && imageTypes.some(e => fileTypes.includes(e)) ) {
            iconColor = `mdi mdi-file-document-multiple text-danger-pink`;
        }
        else if( fileTypes?.includes('application/pdf') ){
            iconColor = `mdi mdi-file-document text-danger`;
        }
        else if( imageTypes.some(e => fileTypes?.includes(e)) ){
            iconColor = `mdi mdi-file-image text-pink`;
        }
    }

    return iconColor;
}


Vue.prototype.$humanFileSize = (size, decimalPoint=2) =>  {
    let i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(decimalPoint) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}


Vue.prototype.$sumFileSize = ({array, key, decimal, convert=true}) => {
    if (!Array.isArray(array) || array.length === 0) {
        return 0;
    }

    let sum = array.reduce((accumulator, object) => {
        return accumulator + object[key];
    }, 0);
    
    return convert ? Vue.prototype.$humanFileSize( isNaN(sum) ? 0 : sum, decimal ) : ( isNaN(sum) ? 0 : sum );
}



Vue.prototype.$validateEmail = (email) => {
    return !!String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}



Vue.prototype.$ustpEmailValidation = (value) => {
    if(process.env.VUE_APP_CLIENT !== 'ustp'){
        return true
    }

    if(value && Vue.prototype.$validateEmail(value)){
        let orgEmail = value.split('@');
        if(orgEmail[1] != 'ustp.edu.ph'){
            return false;
        }
    }

    return true;
}


Vue.prototype.$noSpaceValidation = (value) => {
    if(value){
        return !/\s/g.test(value);
    }

    return true;
}


// encryption/decryption of ID
Vue.prototype.$encryptID = (id) => {
    return Vue.CryptoJS.AES.encrypt(
        id.toString(),
        Vue.prototype.$VUE_APP_SECRET_KEY
    ).toString();
}

Vue.prototype.$decryptID = (id) => {
    return Vue.CryptoJS.AES.decrypt(id.toString(), Vue.prototype.$VUE_APP_SECRET_KEY).toString(Vue.CryptoJS.enc.Utf8);
}



// encryption/decryption of object data
Vue.prototype.$encryptData = (data) => {
    return Vue.CryptoJS.AES.encrypt(
        JSON.stringify(data),
        Vue.prototype.$VUE_APP_SECRET_KEY
    ).toString();
}

Vue.prototype.$decryptData = (data) => {
    let bytes  = Vue.CryptoJS.AES.decrypt(data, Vue.prototype.$VUE_APP_SECRET_KEY);
    return JSON.parse(bytes.toString(Vue.CryptoJS.enc.Utf8));
}



// customize encrytion/decryption for file folder page
Vue.prototype.$encryptRouteID = (textId) => {
    let userData = JSON.parse(localStorage.getItem("USER"));

    let data = {
        id: textId,
        deliveryUnitId: userData?.deliveryUnit?.id
    }

    return Vue.CryptoJS.AES.encrypt(
        JSON.stringify(data),
        Vue.prototype.$VUE_APP_SECRET_KEY
    ).toString();
}

Vue.prototype.$decryptRouteID = (textId) => {
    let bytes  = Vue.CryptoJS.AES.decrypt(textId, Vue.prototype.$VUE_APP_SECRET_KEY);
    return JSON.parse(bytes.toString(Vue.CryptoJS.enc.Utf8));
}


/**
 * 
 * @param {Object} ref Vue instance (this)
 * @param {Number} id folder id
 * @param {String} displayType display-ui or tree-ui
 * @returns 
 */
// eslint-disable-next-line
Vue.prototype.$changeFolder = (ref, id, item, displayType) => {
    const folderPath = `/archive-master/folders/${id}`;
    const myFolderPath = ['/', '/archive-master/my-office'];
    
    if (ref.$route.path !== folderPath && id !== 0) {
        // E encrypt ang id
        let encryptId = Vue.prototype.$encryptRouteID(id.toString());
        
        ref.$router.push({ name: 'Folder ID', params: { id: encryptId } }).catch(() => {});

        // set breadcrumb
        // if(displayType === 'tree-ui'){
        //     ref.$store.commit('fileManager/breadcrumb/setBreadCrumbByTree', item);
        // }
        // else if(displayType === 'display-ui'){
        //     ref.$store.commit('fileManager/breadcrumb/setBreadCrumb', item);
        // }
    }
    else if(!myFolderPath.includes(ref.$route.path)){
        ref.$router.push({ name: 'My Folder' }).catch(() => {});

        // ref.$store.commit('fileManager/breadcrumb/setBreadCrumb', null);
    }
}



Vue.prototype.$changeLocation = (ref, id) => {
    const locationPath = `/archive-master/locations/${id}`;
    const myLocationPath = '/archive-master/my-location';
    
    if (ref.$route.path !== locationPath && id !== 0) {
        // E encrypt ang id
        let encryptId = Vue.prototype.$encryptRouteID(id.toString());
        
        return ref.$router.push({ name: 'Location ID', params: { id: encryptId } }).catch(() => {});
    }
    else if(ref.$route.path !== myLocationPath){
        return ref.$router.push({ name: 'My Location' }).catch(() => {});
    }
}


Vue.prototype.$filterItems = (searchText, array, keyArr, arrayItemKey) => {
    return array.filter(item => {
        
        if(arrayItemKey && arrayItemKey !== ''){
            item = Vue.prototype.$getPropByString(item, arrayItemKey);
        }

        return Object.keys(item).some(v => {
            if(typeof item[v] === 'string' && ( keyArr.length ? keyArr.includes(v) : true ) ) return item[v].toLowerCase().includes(searchText.toLowerCase());
        });
    });
}


Vue.prototype.$debounce = (func, time) => {
    let _time = time || 100; // 100 by default if no param
    let _timer;
    return function(event){
        if(_timer) clearTimeout(_timer);
        _timer = setTimeout(func, _time, event);
    };
}



Vue.prototype.$getPropByString = (obj, propString) => {
    if (!propString){
        return obj;
    }

    var prop, props = propString.split('.');

    for (var i = 0, iLen = props.length - 1; i < iLen; i++) {
        prop = props[i];

        var candidate = obj[prop];
        if (candidate !== undefined) {
            obj = candidate;
        } else {
            break;
        }
    }

    return obj[props[i]];
}




Vue.prototype.$deepSearch = (data, value) => {
    if (Array.isArray(data)) {
        for (var i = 0; i < data.length; i++) {
            if (Vue.prototype.$deepSearch(data[i], value)) {
                return true;
            }
        }
    } else if (typeof data === 'object') {
        for (var key in data) {
            if (Object.hasOwn(data, key) && Vue.prototype.$deepSearch(data[key], value)) {
                return true;
            }
        }
    } else {
      return data.toString().toLowerCase().trim().includes( value.toString().toLowerCase().trim() );
    }

    return false;
}

function searchMatch(objValue, searchValue){
    let serchValueDataType = typeof(searchValue);
    
    if(serchValueDataType === 'string'){
        let _searchValue = searchValue?.toString()?.toLowerCase()?.trim();

        return objValue.match( new RegExp(_searchValue, 'gi') );
    }
    else if(serchValueDataType === 'object' && Array.isArray(searchValue)){ // array, multiple search value
        
        return searchValue.some((e) => {

            let _searchValue = e?.toString()?.toLowerCase()?.trim();

            return objValue.match( new RegExp(_searchValue, 'gi') );

        
        });
        // return objValue.match( new RegExp(searchValue.join(' '), 'gi') );
    
    }

}

function deepSearch(obj, searchValue, searchKeyArr, excludeObjectKeyArr=[]) {
    for (let key in obj) {
        let _objValue = obj[key]?.toString()?.toLowerCase()?.trim();
        
        if ( _objValue && searchValue && searchKeyArr.includes(key)) {
            if(searchMatch(_objValue, searchValue)){
                return true;
            }
        }

        if (typeof obj[key] === 'object' && obj[key] !== null && !excludeObjectKeyArr.includes(key)) {

            // custom function: because  two or more key name have the same value
            // documentCategory: { id: 1035, category: "Approved Budget Contact ", description: "Approved Budget Contact Document" }
            if(key === 'documentCategory'){
                // delete/remove ang duplicate na description sa documentCategory
                delete obj[key]["description"];
            }


            if (deepSearch(obj[key], searchValue, searchKeyArr, excludeObjectKeyArr)) {
                return true;
            }
        }
    }

    return false;
}
  
Vue.prototype.$deepFilterArray = (array, searchValue, includeKeyArr=[], excludeObjectKeyArr=[]) => {
    let _searchKeyArr = ['name', 'description', 'tag', 'category', 'fileName', ...includeKeyArr];
    let _excludeObjectKeyArr = ['deliveryUnit', ...excludeObjectKeyArr];

    return array.filter(item => deepSearch(item, searchValue, _searchKeyArr, _excludeObjectKeyArr));
}

Vue.prototype.$categoryFilterArray = (array, searchValue) => {
    if(!array?.length){
        return []
    }

    return array.filter(item =>
        item.documentCategory.toLowerCase().includes(searchValue.toLowerCase()) ?? item.documentCategory.category.toLowerCase().includes(searchValue.toLowerCase())
    );
}

Vue.prototype.$folderFilterArray = (array, searchValue) => {
    if(!array?.length){
        return []
    }

    return array.filter(item =>
        item.name.toLowerCase().includes(searchValue.toLowerCase())
    );
}

Vue.prototype.$documentFilterArray = (array, searchValue) => {
    if(!array?.length){
        return []
    }

    return array.filter(item =>
        item.fileTags.toLowerCase().includes(searchValue.toLowerCase())
    );
}

Vue.prototype.$tagsFilterArray = (array, searchValue) => {
    if(!array?.length){
        return []
    }

    return array.filter(item =>
        item.fileTags.some(fileTag =>
          fileTag.tag.toLowerCase().includes(searchValue.toLowerCase())
        )
    );
}

  
Vue.prototype.$camel2title = (camelCase) => {
    // no side-effects
    return camelCase
        // inject space before the upper case letters
        .replace(/([A-Z])/g, function(match) {
            return " " + match;
        })
        // replace first char with upper case
        .replace(/^./, function(match) {
            return match.toUpperCase();
        });
}


Vue.prototype.$nameFormat = (name) => {
    if (!name) return ""

    return name
      .split(" ")
      .map((map) => {
        return map.charAt(0).toUpperCase() + map.slice(1).toLowerCase();
      })
      .join(" ");
};


Vue.prototype.$dragWithCustomDiv = (event, item, totalMultipleItems, isMultiple) => {
    const containerDiv = document.createElement("div");

    const topDiv = document.createElement("div");

    topDiv.id = 'custom-document-drag-top-div';
    topDiv.innerHTML = item?.name || '';
    topDiv.style.backgroundColor = "blue";
    topDiv.style.fontSize = "1rem";
    topDiv.style.color = "white";
    topDiv.style.padding = "10px 30px 10px 20px";
    topDiv.style.position = "absolute";
    topDiv.style.opacity = 1;
    topDiv.style.zIndex = 2;
    topDiv.style.width = '185px';
    topDiv.style.whiteSpace = 'nowrap';
    topDiv.style.overflow = 'hidden';
    topDiv.style.textOverflow = 'ellipsis';
    
    if(isMultiple){
        const bottomDiv = document.createElement("div");

        bottomDiv.id = 'custom-document-drag-bottom-div';
        bottomDiv.innerHTML = item?.name || '';
        bottomDiv.style.backgroundColor = "blue";
        bottomDiv.style.fontSize = "1rem";
        bottomDiv.style.color = "transparent";
        bottomDiv.style.padding = "10px 30px 10px 20px";
        bottomDiv.style.position = "absolute";
        bottomDiv.style.opacity = 0.25;
        bottomDiv.style.zIndex = 1;
        bottomDiv.style.margin = '4px 4px 0';
        bottomDiv.style.width = '185px';
        bottomDiv.style.height = '45px';

        const parentCircleDiv = document.createElement("div");

        parentCircleDiv.id = 'custom-document-drag-parent-circle-div';
        parentCircleDiv.style.width = '185px';
        parentCircleDiv.style.position = "absolute";
        parentCircleDiv.style.zIndex = 5;
        parentCircleDiv.style.marginTop = '6px';
        parentCircleDiv.style.paddingRight = '4px';

        const childCircleDiv = document.createElement("div");

        childCircleDiv.id = 'custom-document-drag-child-circle-div';
        childCircleDiv.innerHTML = totalMultipleItems || '';
        childCircleDiv.style.height = '30px';
        childCircleDiv.style.width = '30px';
        childCircleDiv.style.borderRadius = '20px';
        childCircleDiv.style.border = '1px solid orange';
        childCircleDiv.style.backgroundColor = 'red';
        childCircleDiv.style.color = 'white';
        childCircleDiv.style.float = 'right';
        // childCircleDiv.style.margin = '-17px -14px';
        childCircleDiv.style.textAlign = 'center';
        childCircleDiv.style.paddingTop = '4px';
        parentCircleDiv.style.zIndex = 5;
        // childCircleDiv.style.fontWeight = 'bold';

        if(totalMultipleItems){
            parentCircleDiv.appendChild(childCircleDiv);
            containerDiv.appendChild(bottomDiv);
        }
        containerDiv.appendChild(topDiv);
        containerDiv.appendChild(parentCircleDiv);
    }
    else if(!isMultiple){
        containerDiv.appendChild(topDiv);
    }

    document.body.appendChild(containerDiv);
    event.dataTransfer.setDragImage(containerDiv, 0, 0);

    setTimeout(() => {
        document.body.removeChild(containerDiv);
    }, 10);
};


Vue.prototype.folderOrFilesMsg = (folders, files) => {
    if (!folders?.length && !files?.length) return ""

    let _folderMsg = `${folders?.length} folder${folders?.length > 1 ? 's' : ''}`;
    let _fileMsg = `${files?.length} file${files?.length > 1 ? 's' : ''}`;

    if(folders?.length && files?.length){
        return `${_folderMsg}, ${_fileMsg}`;
    }
    else if(folders?.length && !files?.length){
        return _folderMsg;
    }
    else if(!folders?.length && files?.length){
        return _fileMsg;
    }

    return ""
};


Vue.prototype.$getFile = async (id) => {
    Vue.prototype.$swal({
        title: 'Getting file .. Please wait',
        allowOutsideClick: false,
    });
    Vue.prototype.$swal.showLoading();

    try{
        let res = await axiosSwagger.get(`/api/FileManagerFile/ReadFile/Stream/${id}`, {responseType: 'blob'})
        let contentType = res.headers["content-type"];

        if (contentType.includes("json")) {
            return false;
        }

        let cd = res.headers["content-disposition"];
        let cdArr = cd.split(";");
        let filename = cdArr[1].trim().replace('filename=', '');
        var url = URL.createObjectURL(res.data);

        if(contentType.includes("pdf") || contentType.includes("image")){
            window.open(url, '_blank');
        }
        else{
            var a = document.createElement("a");
            a.setAttribute("download", `${filename}`);
            a.setAttribute("href", url);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }

        Vue.prototype.$swal.close();
        return true;
    }catch(e){
        Vue.prototype.$swal.close();
        return false;
    }
}

Vue.prototype.$getStreamFileReader = async (id, isPublic = false) => {
    let url = isPublic ? 'api/FileManagerFile/ReadFile/Public' : 'api/FileManagerFile/ReadFile/Stream';

    const response = await fetch(`${Vue.prototype.$VUE_APP_SWAGGER_URL}/${url}/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem('TOKEN')}`,
        },
    });
    if (!response.ok) throw new Error('Failed to fetch image');

    return response;
}

Vue.prototype.$uploadStreamFile = async (formData) => {
    const response = await fetch(`${Vue.prototype.$VUE_APP_SWAGGER_URL}/api/FileManagerFile/Upload`, {
        method: "POST",
        body: formData
    });
    if (!response.ok) throw new Error('Upload failed');

    return response;
}


/**
 * 
 * @param {Object} ref Vue instance (this)
 * @param {Number} id folder id
 * @param {String} displayType display-ui or tree-ui
 * @returns 
 */
// eslint-disable-next-line
Vue.prototype.$changeFolderDetails = async (ref, id, item, displayType) => {
    if (id !== 0) {
        return await ref.$store.dispatch('pool/postFolder/readFolderDetailsById', id)
            .then((response) => {
                return response;
            });
    }
}
